export const data = [
    {
        label: '审核中',
        value: '0',
        type: 'warning',
    },
    {
        label: '审核通过',
        value: '1',
        type: 'success',
    },
    {
        label: '审核不通过',
        value: '2',
        type: 'danger',
    },
    {
        label: '待提交',
        value: '9',
        type: 'info',
    },
];

export function getLabelByKey(key) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].value === key) {
            return data[i].label;
        }
    }

    return '';
}

export function getTypeByKey(key) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].value === key) {
            return data[i].type;
        }
    }

    return '';
}
